var searchResultsObject = {},
	searchContentType = getURLParameter('contentType'),
	searchSortType = getURLParameter('sortType'),
	resultsPerPage = 20,
	filterOpened = false,
	loadAjax = true;

$(function() {

  // Search Toggle
  $("[data-js-search-toggle]").click(function (e) { 
    e.preventDefault();
    
    $("#language_select").hide();
    $("#header_search").toggleClass("open");

    $('#site-wrapper').removeClass('show-nav');

    $(".js-nav-dropdown").find("[class*='icon--']").toggleClass("icon--burger").toggleClass("icon--cross").attr('title','Close');
    $('#site-wrapper').toggleClass('show-search');

	  if($("#header_search").hasClass("open")){
		  $('#header_search_input').focus();
	  } else {
		  $(".menu-dropdown--search").removeClass("active");
	  }

  });

    /**
     * Clicking Market Language Selector in Header to close header fly-out
     */
    $('.mobile-menu__footer a, .mobile-menu__header .nav-dropdown__language').on('click', function(){
        $('.js-nav-dropdown')[0].click();
    });

   // prevent the dropdown from closing when selecting a search result
   $(".search__history__link").on("click", function(e) {
    e.stopPropagation();
      
  });

    // full search pills
	$(document).on("click", ".pill-fullsearch", function() {
		showLoadingSpinner();
		var contentType = $(this).data('content-type');

		// $(".scroller").empty();
		$.ajax({
			url: contextPath+"/search/quicksearch",
			method: "GET",
			data: {
				text: fullSearchText,
				contentType: contentType
			},
			success: function (resultMap) {
				var searchResults=resultMap.searchData;
				var hideAddToCart=resultMap.hideAddToCart;
				searchResults["contentType"] = contentType;
				searchResults["searchText"] = fullSearchText;
				if (!searchResultsObject[contentType]['initialized']) {
					resetLazyLoadObject();
                    searchResults["gridSort"] = (searchResultsObject[contentType] !== undefined) ? searchResultsObject[contentType]["gridSort"] : "grid";
					renderFullResults(searchResults,hideAddToCart);
					searchResultsObject[contentType]['initialized'] = true;
				}
				searchContentType = contentType;
				hideLoadingSpinner();
			}
		});
	});

    $(document).on('click', function(event) {
        if (!$(event.target).closest('.sort-options').length) {
            $('.sort-options').hide();
        }
    });

	$(document).on('click','.sort-toggle', function(e){
	    e.stopPropagation();
		$(this).closest('.tab-pane').find('.sort-options').toggle();
	});

    $(document).on('click','#pills-results-product .sort-options li, #pills-results-blog .sort-options li, #pills-results-other .sort-options li, ' +
        '#sort-types-product-mobile li, #sort-types-blog-mobile li, #sort-types-other-mobile li', function(e){
        filterCall(this);
        $(this).closest('.tab-pane').find('.sort-options').hide();
    });

	$.each($('#search-pills').find('li.nav-item a'), function() {
		var currentContentType = $(this).data('content-type');

		searchResultsObject[currentContentType] = {};
		resetLazyLoadObject();
	});

	$('.mobile-sort__btn').click(function(e){
		e.stopPropagation();
		$(this).siblings('.drill-filter__list').toggle();
	});
	$('.mobile-filter__btn').click(function(e){
		e.stopPropagation();
		$(this).siblings('.drill-filter__list').toggle();
		$(this).closest('.container').find('.search-filter__footer').toggle();
	});
});//end document ready

function resetLazyLoadObject() {
	Object.keys(searchResultsObject).map(function(key){
	    searchResultsObject[key]['lazyLoadPageNo'] = 1;
        searchResultsObject[key]['moreSearchPages'] = itemCount[key] > 20;
        searchResultsObject[key]['initialized'] = searchResultsObject[key]['initialized'] === true || key === searchContentType;
        if (searchResultsObject[key]["gridSort"] === undefined || searchResultsObject[key]["gridSort"] === "") {
            searchResultsObject[key]["gridSort"] = "grid";
        }
        return searchResultsObject;
	});
}

function renderFullResults(results,hideAddToCart) {
    $("#fullsearch-"+results["contentType"].toLowerCase()).html($("#fullSearchResultsTemplate"+results["contentType"]).tmpl({data: results,hideAddToCart:hideAddToCart}));
    ACC.product.bindToAddToCartForm();
    $('[data-toggle="tooltip"]').tooltip();
    //check active sort in dropdown
    var defaultSort = "relevance";
    var $contentSort = $("#pills-results-"+results["contentType"].toLowerCase()).find('.sort-options');
    if(!$contentSort.find('li.active').length){
        $contentSort.find('li[data-sort-code="'+defaultSort+'"]').addClass("active");
    }
}

function renderFilterSortFullResults(results,hideAddToCart) {
	$("#fullsearch-"+results["searchContentType"].toLowerCase()).html($("#fullSearchResultsTemplate"+results["searchContentType"]).tmpl({data: results,hideAddToCart:hideAddToCart}));
	ACC.product.bindToAddToCartForm();
	$('[data-toggle="tooltip"]').tooltip();
	//check active sort in dropdown
	var defaultSort = (results.sortType !== undefined && results.sortType !== "")? results.sortType :"relevance";
	var $contentSort = $("#pills-results-"+results["searchContentType"].toLowerCase()).find('.sort-options');
	var currentSort = $contentSort.find('li.active').data('sortCode');
//	if(!$contentSort.find('li.active').length){
    $contentSort.find('li[data-sort-code="'+currentSort+'"]').removeClass("active");
	$contentSort.find('li[data-sort-code="'+defaultSort+'"]').addClass("active");
	searchResultsObject[results.searchContentType]['searchSortType'] = currentSort;
//	}
}


function renderRecentSearch(searchText) {
	var encodedSearchValue = encodeURI(searchText).replace(/\#/g, '%23').replace(/\&/g, '%26').replace(/\@plus/g, '%2B');
	var displaySearchValue = decodeURIComponentSafe(searchText.replace(/\+/g, '%20').replace(/\@plus/g, '+'));
  $('ul.search__history__list').append('<li class="search__history__item"><a class="search__history__link" href="'+contextPath+'/search/fullsearch?text='+encodedSearchValue+'&contentType=PRODUCT" onclick="showLoadingSpinner()">'+displaySearchValue+'</a></li>');
}

function decodeURIComponentSafe(s) {
	if (!s) {
		return s;
	}
	return decodeURIComponent(s.replace(/%(?![0-9][0-9]+)/g, '%25'));
}

if ($('#search-results').length > 0) {
    window.onscroll = function() {checkLazyLoad('#search-pills-tabContent')};
}

function checkLazyLoad(container) {
    var $activePanelBody = $(container).find('.show').find('.search-panel__body');

	if ($(container).offset() && ($(window).scrollTop() > $(container).height() - $(container).offset().top - 600) && searchResultsObject[searchContentType]['moreSearchPages'] && loadAjax) {
		loadAjax = false;

		$activePanelBody.append("<div class='spinner spinner--brand spinner--md lazy-load' role='status'><span class='sr-only'>Loading...</span></div>");

		$.ajax({
			url: contextPath+"/search/quicksearch",
			method: "GET",
			data: {
				text: fullSearchText,
				pageNo: searchResultsObject[searchContentType]['lazyLoadPageNo'],
				sortType: searchResultsObject[searchContentType]['searchSortType']? searchResultsObject[searchContentType]['searchSortType'] : "",
				contentType: searchContentType,
				filterCategories: searchResultsObject[searchContentType]['filterList']
			},
			success: function (resultMap) {
				var searchResults=resultMap.searchData;
				var hideAddToCart=resultMap.hideAddToCart;
				$activePanelBody.find('.spinner').remove();
                searchResults["gridSort"] = searchResultsObject[searchContentType]["gridSort"];

                $activePanelBody.find('div[id*=\'fullsearch\']').append($("#fullSearchResultsTemplate" + searchContentType).tmpl({data: searchResults,hideAddToCart: hideAddToCart}));
				ACC.product.bindToAddToCartForm();
				searchResultsObject[searchContentType]['lazyLoadPageNo'] += 1;
				if (searchResultsObject[searchContentType]['lazyLoadPageNo'] >= searchResults.numberOfPages) {
					searchResultsObject[searchContentType]['moreSearchPages'] = false;
				}
				bindWishlistIconClick();
				bindWishlistIcons();
			},
			complete: function() {
                loadAjax = true;
                $('[data-toggle="tooltip"]').tooltip();                
			}
		});
	}
}

function getURLParameter(name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

// function to make URL call to backend search
function filterCall(context)
{
	showLoadingSpinner();
    var filterList = "";
    var contentType = $(context).data('content-type');
    if (contentType === undefined) contentType = $('#search-filter-apply-button').data('content-type');
    var sortType = $(context).data('sortCode');
    filterList = getFilterList(contentType);
    sortType = (sortType !== undefined && sortType !== "")?
        sortType : (searchResultsObject[contentType]['searchSortType'] !== undefined && searchResultsObject[contentType]['searchSortType'] !== "")?
            searchResultsObject[contentType]['searchSortType'] : "relevance";
    // console.log("filterCall: contentType="+contentType+", filterList="+filterList+", sortType="+sortType);

    // $(".scroller").empty();
    $.ajax({
        url: contextPath+"/search/quicksearch",
        method: "GET",
        data: {
            text: fullSearchText,
            contentType: contentType,
            sortType: sortType,
            filterCategories: filterList
        },
        success: function (resultMap) {
            // current state not individual pills
        	var searchResults=resultMap.searchData;
        	var hideAddToCart=resultMap.hideAddToCart;
            searchResults["searchContentType"] = contentType;
            searchResults["searchText"] = fullSearchText;
            searchResults["sortType"] = sortType;
            searchResults["gridSort"] = searchResultsObject[contentType]["gridSort"];
            resetLazyLoadObject();
            renderFilterSortFullResults(searchResults,hideAddToCart);
            searchResultsObject[contentType]['initialized'] = true;
            searchResultsObject[contentType]['filterList'] = filterList;
            searchResultsObject[contentType]['filterOpened'] = false;
            searchResultsObject[contentType]['searchSortType'] = sortType;

            searchContentType = contentType;
            hideLoadingSpinner();
        }
    });
}

// grabs the filter list codes for the search call with filterCategories
function getFilterList(contentType) {
    var filterList = "";
    var item = $("#pills-results-"+contentType.toLowerCase()+".tab-pane.active.show").find(".drill-filter__list").not('#sort-types-product-mobile').find(".drill-filter__node--focus");

    // get the overall total of selected nodes
    item.each(function () {
        var filter_node_id = $(this).data("filter-node-id");
        if (filter_node_id !== undefined) {
            filterList += $(this).data("filter-node-id") + ",";
        }
    });
    if (filterList !== "" && filterList !== undefined) {
        filterList = filterList.replace(/,$/, "");
    }
    return filterList;
}
